<p-menu [model]="items" [style]="{'width':'249px', 'border': 'none', 'background': 'none'}"></p-menu>
